<template>
	<div
		class="container"
		:class="[navLeftSwitch == 'show' ? '' : 'navbar-vertical-collapsed']"
		data-layout="container"
	>
		<div
			class="position-fixed w-100 d-none d-xl-block"
			:class="{ 'bg-blue-bg': $route.name === 'Testing' }"
			style="z-index: 1040; height: 82px;"
		>
			<router-link class="navbar-brand" to="/">
				<div class="d-flex align-items-center py-3">
					<img
						class="mt-2"
						src="../assets/logo.svg"
						alt=""
						width="200"
					/>
				</div>
			</router-link>
		</div>
		<NavLeft></NavLeft>

		<div class="content">
			<NavTop></NavTop>

			<transition name="fade" mode="out-in">
				<router-view />
			</transition>

			<footer class="footer">
				<div
					class="row g-0 justify-content-between fs--1 mt-4 mb-3 ff-ch"
				>
					<div class="col-12 col-sm-auto text-center">
						<p class="mb-0 text-600"
							>Thank you for joining the SMA PowerUp</p
						>
					</div>
					<div class="col-12 col-sm-auto text-center">
						<p class="mb-0 text-600 lh-base">
							2021
							<a href="">©Biogen</a> copy rights reserved
							<span class="d-none d-sm-inline">|</span
							><br class="d-sm-none" />
							Biogen-145353-TW-12/2021
						</p>
					</div>
				</div>
			</footer>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import NavLeft from "./nav/NavbarLeft.vue";
import NavTop from "./nav/NavbarTop.vue";

export default {
	computed: {
		...mapGetters(["navLeftSwitch", "navTopSwitch", "token"]),
	},

	components: {
		NavLeft,
		NavTop,
	},

	watch: {
		$route: function() {
			if (this.$route.name == "Home") {
				this.$router.push("/test");
			}
		},
	},
};
</script>

<style lang="scss" scoped></style>
